var _path, _path2, _circle, _path3, _ellipse, _path4, _path5, _path6, _path7, _circle2, _ellipse2, _path8, _path9, _path10, _path11, _circle3, _rect, _rect2, _rect3, _rect4, _path12, _path13, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHappy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 206,
    viewBox: "0 0 197 206",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160.759 104C160.759 138.794 130.538 167 93.2588 167C55.9796 167 25.7588 138.794 25.7588 104C25.7588 69.2061 55.9796 41 93.2588 41C130.538 41 160.759 69.2061 160.759 104Z",
    fill: "url(#paint0_linear_281_194)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7588 27H97.7588V43H87.7588V27Z",
    fill: "url(#paint1_linear_281_194)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 92.7588,
    cy: 15,
    r: 14,
    fill: "#000F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.7588 172C133.523 172 165.759 142.003 165.759 105C165.759 82.6271 153.974 62.8154 135.867 50.6466C134.185 49.5167 132.187 48.9738 130.161 48.9738H57.3566C55.3308 48.9738 53.3322 49.5167 51.6508 50.6466C33.5431 62.8154 21.7588 82.6271 21.7588 105C21.7588 142.003 53.9943 172 93.7588 172Z",
    fill: "url(#paint2_linear_281_194)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.5212,
    cy: 147.972,
    rx: 5.29423,
    ry: 9.92668,
    transform: "rotate(-44.9872 42.5212 147.972)",
    fill: "#236DC1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.6175 157.846C56.3308 155.092 54.0653 148.461 48.5575 143.034C43.0497 137.608 36.3851 135.441 33.6719 138.195C30.9586 140.949 33.224 147.581 38.7319 153.007C44.2397 158.434 50.9043 160.6 53.6175 157.846ZM48.8857 154.316C50.6121 152.563 49.1707 148.344 45.6661 144.891C42.1615 141.438 37.9209 140.059 36.1945 141.812C34.468 143.564 35.9095 147.784 39.4141 151.236C42.9187 154.689 47.1593 156.068 48.8857 154.316Z",
    fill: "#468BDC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.716 150.302L49.8088 146.373L41.9514 140.187L38.8586 144.116L46.716 150.302ZM30 155.5L30.9806 160.403L30 155.5ZM19.4224 144.876C18.1339 142.433 15.1095 141.498 12.6671 142.786C10.2247 144.075 9.28918 147.099 10.5776 149.542L19.4224 144.876ZM38.8586 144.116C36.1125 147.604 34.098 148.99 32.8262 149.611C31.4705 150.272 30.7997 150.241 29.0194 150.597L30.9806 160.403C31.7003 160.259 34.3398 159.999 37.2111 158.598C40.1664 157.156 43.2955 154.647 46.716 150.302L38.8586 144.116ZM29.0194 150.597C29.2702 150.547 28.9334 150.653 27.7692 150.292C26.7477 149.975 25.5104 149.43 24.2383 148.713C22.9727 148 21.7967 147.187 20.8773 146.405C20.4203 146.016 20.063 145.666 19.8025 145.372C19.6741 145.227 19.5803 145.108 19.5148 145.017C19.4826 144.972 19.4595 144.937 19.444 144.912C19.4283 144.887 19.422 144.875 19.4224 144.876L10.5776 149.542C11.5094 151.308 13.0034 152.836 14.3982 154.022C15.868 155.272 17.5839 156.442 19.3296 157.425C21.0689 158.405 22.9622 159.271 24.8073 159.843C26.5096 160.371 28.7751 160.844 30.9806 160.403L29.0194 150.597Z",
    fill: "#000F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6782 150.349L49.818 146.457L42.0357 140.178L38.8958 144.069L46.6782 150.349ZM33 155L31.2913 150.301L33 155ZM20.1154 143.077C19.0533 140.528 16.1259 139.323 13.5769 140.385C11.0279 141.447 9.82253 144.374 10.8846 146.923L20.1154 143.077ZM10.8846 146.923C11.1383 147.532 11.4307 148.119 11.7508 148.682L20.4427 143.737C20.306 143.497 20.1983 143.276 20.1154 143.077L10.8846 146.923ZM32.3792 160.272C33.1516 160.165 33.9345 159.98 34.7087 159.699L31.2913 150.301C31.2357 150.321 31.1433 150.348 31.0043 150.367L32.3792 160.272ZM34.7087 159.699C34.9542 159.61 35.1824 159.529 35.3951 159.456L32.1415 150C31.8754 150.092 31.5926 150.191 31.2913 150.301L34.7087 159.699ZM46.1775 150.971C46.3379 150.771 46.5047 150.564 46.6782 150.349L38.8958 144.069C38.7163 144.291 38.5438 144.506 38.3779 144.712L46.1775 150.971Z",
    fill: "#0F4688"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.2071 149.209C52.1452 147.155 50.5672 145.014 48.5575 143.034C45.4408 139.964 41.9538 137.937 39.0219 137.255L40.2591 141.398C41.9742 141.954 43.9123 143.163 45.6661 144.891C47.0723 146.276 48.1464 147.785 48.8169 149.209H53.2071Z",
    fill: "#468BDC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5557,
    cy: 138.556,
    r: 10.625,
    transform: "rotate(-30.6263 11.5557 138.556)",
    fill: "#85B7F2"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.29423,
    cy: 9.92668,
    rx: 5.29423,
    ry: 9.92668,
    transform: "matrix(-0.875304 -0.483572 -0.483572 0.875304 167.942 127.576)",
    fill: "#236DC1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.578 146.265C147.209 144.369 147.55 137.37 151.341 130.631C155.131 123.892 160.936 119.965 164.305 121.861C167.675 123.756 167.334 130.756 163.543 137.495C159.752 144.234 153.948 148.16 150.578 146.265ZM154.148 141.562C152.004 140.356 152.221 135.903 154.633 131.615C157.045 127.327 160.738 124.828 162.882 126.034C165.026 127.24 164.809 131.694 162.397 135.982C159.985 140.27 156.292 142.768 154.148 141.562Z",
    fill: "#468BDC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M155.122 137.105L151.062 134.185L156.901 126.067L160.96 128.986L155.122 137.105ZM172.624 137.473L173.038 142.456L172.624 137.473ZM179.847 124.336C180.409 121.633 183.057 119.897 185.76 120.459C188.464 121.021 190.2 123.668 189.638 126.372L179.847 124.336ZM160.96 128.986C164.564 131.578 166.884 132.352 168.278 132.596C169.763 132.857 170.4 132.641 172.209 132.49L173.038 142.456C172.307 142.517 169.699 142.998 166.552 142.446C163.313 141.879 159.611 140.333 155.122 137.105L160.96 128.986ZM172.209 132.49C171.954 132.512 172.307 132.52 173.326 131.851C174.22 131.264 175.258 130.398 176.282 129.357C177.3 128.321 178.206 127.215 178.873 126.209C179.204 125.709 179.451 125.273 179.619 124.918C179.703 124.743 179.76 124.603 179.797 124.497C179.816 124.445 179.829 124.405 179.837 124.377C179.845 124.349 179.848 124.336 179.847 124.336L189.638 126.372C189.232 128.327 188.219 130.209 187.207 131.735C186.14 133.343 184.815 134.942 183.41 136.37C182.01 137.793 180.43 139.149 178.816 140.209C177.326 141.188 175.28 142.269 173.038 142.456L172.209 132.49Z",
    fill: "#000F20"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M155.171 137.139L151.077 134.269L156.817 126.081L160.911 128.951L155.171 137.139ZM169.602 137.823L169.944 132.835L169.602 137.823ZM178.684 122.8C178.999 120.056 181.478 118.088 184.221 118.403C186.965 118.718 188.933 121.197 188.618 123.941L178.684 122.8ZM188.618 123.941C188.543 124.596 188.424 125.241 188.273 125.87L178.552 123.525C178.617 123.256 178.659 123.014 178.684 122.8L188.618 123.941ZM171.658 142.717C170.886 142.828 170.083 142.868 169.261 142.811L169.944 132.835C170.003 132.839 170.099 132.839 170.238 132.819L171.658 142.717ZM169.261 142.811C169 142.794 168.759 142.779 168.534 142.768L169.043 132.781C169.324 132.795 169.624 132.813 169.944 132.835L169.261 142.811ZM155.824 137.599C155.615 137.451 155.397 137.298 155.171 137.139L160.911 128.951C161.145 129.115 161.37 129.273 161.587 129.426L155.824 137.599Z",
    fill: "#0F4688"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.582 137.851C149.034 135.583 149.958 133.09 151.341 130.631C153.486 126.818 156.276 123.905 158.904 122.438L158.862 126.762C157.368 127.771 155.84 129.469 154.633 131.615C153.665 133.335 153.051 135.082 152.8 136.636L148.582 137.851Z",
    fill: "#468BDC"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.625,
    cy: 10.625,
    r: 10.625,
    transform: "matrix(-0.967893 -0.251362 -0.251362 0.967893 198.612 108.473)",
    fill: "#85B7F2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 145,
    width: 1.5,
    height: 10.5,
    rx: 0.75,
    fill: "#5998E1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 145,
    width: 1.5,
    height: 10.5,
    rx: 0.75,
    fill: "#5998E1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 93.5,
    y: 142,
    width: 1.5,
    height: 18,
    rx: 0.75,
    fill: "#5998E1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 67,
    width: 116,
    height: 61,
    rx: 30.5,
    fill: "#000F20",
    stroke: "#458DDE",
    strokeWidth: 4
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M80 94C80 92.6868 79.7413 91.3864 79.2388 90.1732C78.7362 88.9599 77.9997 87.8575 77.0711 86.9289C76.1425 86.0003 75.0401 85.2638 73.8268 84.7612C72.6136 84.2587 71.3132 84 70 84C68.6868 84 67.3864 84.2587 66.1732 84.7612C64.9599 85.2638 63.8575 86.0003 62.9289 86.9289C62.0003 87.8575 61.2638 88.9599 60.7612 90.1732C60.2587 91.3864 60 92.6868 60 94",
    stroke: "#72B2FF",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M130 94C130 92.6868 129.741 91.3864 129.239 90.1732C128.736 88.9599 128 87.8575 127.071 86.9289C126.142 86.0003 125.04 85.2638 123.827 84.7612C122.614 84.2587 121.313 84 120 84C118.687 84 117.386 84.2587 116.173 84.7612C114.96 85.2638 113.858 86.0003 112.929 86.9289C112 87.8575 111.264 88.9599 110.761 90.1732C110.259 91.3864 110 92.6868 110 94",
    stroke: "#72B2FF",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_281_194",
    x1: 93.2588,
    y1: 27,
    x2: 93.2588,
    y2: 167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58A1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#7E9DC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_281_194",
    x1: 93.2588,
    y1: 27,
    x2: 93.2588,
    y2: 167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58A1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#7E9DC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_281_194",
    x1: 93.7588,
    y1: 38,
    x2: 93.7588,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83B5F1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappy);
export default __webpack_public_path__ + "static/media/happy.182c7fa236bba54d7adf09da6584e87c.svg";
export { ForwardRef as ReactComponent };